export default 'DUCKS/STATION_GUIDES';
